'use client';
import EdgeBanner from './EdgeBanner';
import { usePermission } from '@benzinga/user-context';

export const EdgeContent = ({
  bannerType = 'insider-report',
  children = null,
}: {
  bannerType: 'insider-report' | 'whisper-index';
  children?: React.ReactNode | null;
}) => {
  const hasAccess = usePermission('com/read', 'unlimited-articles');

  if (hasAccess) {
    return children ? <div className="flex flex-col gap-6">{children}</div> : null;
  }

  return (
    <div className="relative">
      <EdgeBanner type={bannerType} />
    </div>
  );
};

export default EdgeContent;
